import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "clinicianInput",
    "clinicianSection",
    "clinicianNav",
    "telehealth",
    "licensedStates",
    "disclosure",
    "disclosureExplanation"
  ]

  connect() {
    this.syncClinician()
    this.syncLicensedStates()
    this.syncDisclosureExplanation()
  }

  toggleClinician() {
    this.syncClinician()
  }

  toggleTelehealth() {
    this.syncLicensedStates()
  }

  toggleDisclosure() {
    this.syncDisclosureExplanation()
  }

  syncClinician() {
    if (!this.hasClinicianInputTarget) return

    const on = this.clinicianInputTarget.checked
    this.clinicianSectionTargets.forEach((section) => {
      section.hidden = !on
    })
    this.clinicianNavTargets.forEach((group) => {
      group.hidden = !on
    })
    if (on) {
      this.syncLicensedStates()
      this.syncDisclosureExplanation()
    }
  }

  syncLicensedStates() {
    if (!this.hasLicensedStatesTarget) return

    const enabled = this.hasTelehealthTarget && this.telehealthTarget.value === "yes"
    this.licensedStatesTarget.classList.toggle("is-unavailable", !enabled)
    this.licensedStatesTarget.querySelectorAll("button, input, select").forEach((element) => {
      element.disabled = !enabled
    })
  }

  syncDisclosureExplanation() {
    if (!this.hasDisclosureExplanationTarget) return

    const show = this.hasDisclosureTarget && this.disclosureTarget.value === "yes"
    this.disclosureExplanationTarget.hidden = !show
  }
}
